import React from 'react';
import ReactMarkdown from 'react-markdown';

// Externe links (bv. het inschrijvingsplatform) openen in een nieuw tabblad,
// net als de externe knoppen elders op de site.
const isExternal = (href) => /^https?:\/\//i.test(href || '');

export default function Markdown({ content, className }) {
  if (!content) return null;
  return (
    <div className={`md ${className || ''}`}>
      <ReactMarkdown
        components={{
          a: ({ href, children, ...props }) => (
            <a
              href={href}
              target={isExternal(href) ? '_blank' : undefined}
              rel={isExternal(href) ? 'noopener noreferrer' : undefined}
              {...props}
            >
              {children}
            </a>
          )
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}